import React, { useState, useRef,useEffect } from "react";
import {
  Home,
  TrendingUp,
  Users,
  BarChart3,
  Package,
  DollarSign,
  Target,
} from "lucide-react";
import { useTheme } from "./context/ThemeContext";

function Profile() {
  const { theme } = useTheme();
  const isDarkMode = theme === "dark";
  const [profile,setProfile] = useState();
  const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;

    useEffect(() => {
      fetchProfile();
    }, []);
  
  const fetchProfile = async () => {
    try {
      const manufacturerId = sessionStorage.getItem("userId");
      console.log("Manufacturer ID:", manufacturerId);
  
      // ✅ Correct URL (no /brickbucket here)
      const apiUrl = `${fetchUrl}manufacturer/get-manufacturer-profile?mfr_id=${manufacturerId}`;
      console.log("Fetching URL:", apiUrl);
  
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
  
      const data = await response.json();
      console.log("profile Data:", data);
  
      if (response.ok && data) {

  
        setProfile(data.data);
      } else {
        console.error(
          "Failed to fetch profile:",
          data.message
        );
      }
    } catch (error) {
      console.error("Error in profile:", error);
    }
  };

  return (
    <div className={`flex flex-col w-full transition-colors duration-300 ${isDarkMode ? 'bg-gray-900' : 'bg-gray-50'}`}>
      {/* Header */}
      <div className={`px-2 py-6 fixed sticky top-0 left-0 right-0 flex items-center shadow-sm h-10 transition-colors duration-300 ${isDarkMode ? 'bg-gray-800 border-b border-gray-700' : 'bg-white border-b border-gray-200'}`}>
        <h1 className={`text-lg font-medium ${isDarkMode ? 'text-white' : 'text-[#000000]'}`}>Profile</h1>
      </div>

      {/* User Profile Card */}
      <div className={`mx-4 mt-4 rounded-lg p-4 shadow-sm transition-colors duration-300 ${isDarkMode ? 'bg-gray-800' : 'bg-white'}`}>
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center">
          <div
            className={`w-12 h-12 rounded-full flex items-center justify-center mr-3 overflow-hidden ${
              isDarkMode ? 'bg-gray-700' : 'bg-[#D9E0F6]'
            }`}
          >
            {profile?.image ? (
              <img
                src={`${process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES}${profile.image}`}
                alt="Profile"
                className="w-full h-full object-cover rounded-full"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = '/default-avatar.png'; // optional fallback
                }}
              />
            ) : (
              <span
                className={`font-bold text-lg ${
                  isDarkMode ? 'text-blue-400' : 'text-[#1A73E7]'
                }`}
              >
                {profile?.name?.charAt(0)?.toUpperCase() || 'U'}
              </span>
            )}
          </div>
            <div>
              <h2 className={`text-lg font-semibold ${isDarkMode ? 'text-white' : 'text-[#000000]'}`}>
                {profile?.name}
              </h2>
              <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                {profile?.designation}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Profile Section */}
      <div className={`mx-4 mt-4 rounded-lg p-4 shadow-sm transition-colors duration-300 ${isDarkMode ? 'bg-gray-800' : 'bg-white'}`}>
        <div className="flex items-center justify-between mb-4">
          <h3 className={`text-sm font-semibold ${isDarkMode ? 'text-white' : 'text-[#000000]'}`}>Personal Information</h3>
        </div>

        <div className="space-y-4">
          {/* Name Field */}
          <div>
            <label className={`block text-xs mb-2 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>Name</label>
            <div className={`w-full p-3 border rounded-md transition-colors duration-300 ${isDarkMode ? 'bg-gray-700 border-gray-600' : 'bg-gray-50 border-gray-200'}`}>
              <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>{profile?.name}</p>
            </div>
          </div>

          {/* Mobile Number Field */}
          <div>
            <div className="flex items-center justify-between mb-2">
              <label className={`block text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                Mobile Number
              </label>
            </div>
            <div className={`w-full p-3 border rounded-md transition-colors duration-300 ${isDarkMode ? 'bg-gray-700 border-gray-600' : 'bg-gray-50 border-gray-200'}`}>
              <p className={`text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-900'}`}>
                {profile?.mobile}
              </p>
            </div>
          </div>

          <div>
            <label className={`block text-xs mb-2 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>Designation</label>
            <div className={`w-full p-3 border rounded-md transition-colors duration-300 ${isDarkMode ? 'bg-gray-700 border-gray-600' : 'bg-gray-50 border-gray-200'}`}>
              <p className={`text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-900'}`}>{profile?.designation || "---"}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Company Information Section */}
      <div className={`mx-4 mt-4 rounded-lg p-4 mb-12 shadow-sm transition-colors duration-300 ${isDarkMode ? 'bg-gray-800' : 'bg-white'}`}>
        <div className="flex items-center justify-between mb-4">
          <h3 className={`text-sm font-semibold ${isDarkMode ? 'text-white' : 'text-[#000000]'}`}>Company Information</h3>
        </div>

        <div className="space-y-4">
          {/* Company Name */}
          <div>
            <label className={`block text-xs mb-2 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>Company Name</label>
            <div className={`w-full p-3 border rounded-md transition-colors duration-300 ${isDarkMode ? 'bg-gray-700 border-gray-600' : 'bg-gray-50 border-gray-200'}`}>
              <p className={`text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-900'}`}>{profile?.company_name}</p>
            </div>
          </div>

          {/* Brand Name */}
          <div className="relative">
            <label className={`block text-xs mb-2 ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>Brand</label>
            <div className={`w-full p-3 border rounded-md transition-colors duration-300 ${isDarkMode ? 'bg-gray-700 border-gray-600' : 'bg-gray-50 border-gray-200'}`}>
              <p className={`text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-900'}`}>{profile?.brand}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Profile;
